import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
    key: 'vuex',
    storage: window.localStorage
})
export default new Vuex.Store({
    state: {
        token: '',
    },
    getters: {
        saToken : (state)=>state.token
    },
    mutations: {
        setToken(state, token) {
            state.token = token
        }
    },
    actions: {
        setToken({commit}, token) {
            commit('setToken', token)
        },
    },
    modules: {},
    plugins: [vuexPersist.plugin]
})
